/**
 * @desc 课程的数据差异抹平处理
 */

const mobileCourseUrlReg = /m\..*\/course.*groupId=\d+/;
/**
 * @desc 对课程做url的抹平处理，m端的课程页转换为pc端的课程页
 * @param {*} mobileUrl
 */
export const getNormalizedJumpCourseUrl = (possibleMobileUrl: string) => {
    const isMobileCourseUrl = mobileCourseUrlReg.test(possibleMobileUrl);
    if (isMobileCourseUrl) {
        const pcUrl = possibleMobileUrl.replace('m.', '');
        return pcUrl;
    } else {
        return possibleMobileUrl;
    }
}

/**
 * @desc 返回PC版本的小节url
 */
export const composePcSessionUrl = (coursePcUrl: string, sessionUrl: string) => {
    const pcCouseUrl = getNormalizedJumpCourseUrl(coursePcUrl);
    const hashSessionRoute = '#/sessionUrl/' + encodeURIComponent(sessionUrl);
    return [pcCouseUrl, hashSessionRoute].join('');
}
